/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { FeedbackMessage } from '@ta-interaktiv/react-feedback-message'
import { Link } from '@ta-interaktiv/contentbricks'
import { Person } from '../person'
import { Icon, Button } from 'semantic-ui-react'
import { TopMenu } from '../menu'
import { Waypoint } from 'react-waypoint'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import './styles.scss'

const ARTICLE_ID = '786163770185'
import heldinnenData from '../../../data/heldinnen.json'

const parseJsonData = json => {
  return json.data
}

const isMobile = window.innerWidth < 769

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      hasTooltipHint: false,
      menuOpen: false,
      toggleSticky: false
    }
    this.closeMenu = this.closeMenu.bind(this)
    this.openMenu = this.openMenu.bind(this)
  }

  openMenu() {
    // console.log('window.pageYOffset:', window.pageYOffset)
    let yOffset = -window.pageYOffset
    this.setState({ menuOpen: true })

    // When the modal is shown, we want a fixed body
    /*
    document.body.style.position = 'fixed'
    document.body.style.top = yOffset + 'px'
    */
  }

  closeMenu() {
    this.setState({ menuOpen: false })
    // When the modal is hidden...
    /*
    const scrollY = document.body.style.top
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, parseInt(scrollY || '0') * -1)
    */
  }

  render() {
    const output = parseJsonData(heldinnenData).map(
      function(person, i) {
        return (
          <Person
            name={person.Name}
            image={person.Bild}
            format={person.Format}
            function={person.Zeitraum}
            text={person.Text}
            key={'person-' + i}
            index={i}
          />
        )
      }.bind(this)
    )

    return (
      <div className={this.state.menuOpen ? 'index menu-open' : 'index'}>
        <Masthead articleId={ARTICLE_ID} inverted />
        <ThemeSwitch />

        <header
          className={
            isMobile
              ? 'mobile ui titleImage inverted'
              : 'ui titleImage inverted'
          }
        >
          <div className='ui container'>
            <div className='ui header headline'>
              <div className='headerWrapper'>
                <h1>Fünfzig Heldinnen</h1>
                <h2>
                  50 Frauen (und ein paar Männer), die halfen, das Stimmrecht
                  für die Frauen einzuführen.
                </h2>
              </div>
            </div>
          </div>
          <div className={isMobile ? 'header-image mobile' : 'header-image'} />
        </header>

        <div className='ui vertical segment'>
          <Waypoint
            scrollableAncestor={window}
            // bottomOffset='400px'
            onLeave={({ previousPosition, currentPosition, event }) => {
              if (currentPosition === Waypoint.above) {
                //console.log('sticky menu')
                this.setState({ toggleSticky: true })
              }
            }}
          >
            <div
              className='menu-toggle'
              style={{
                position: this.state.toggleSticky ? 'fixed' : 'absolute',
                top: this.state.toggleSticky ? ' 1em' : '1.5em'
              }}
            >
              <Button onClick={this.openMenu}>
                <Icon name='bars' />
              </Button>
            </div>
          </Waypoint>
          <Waypoint
            scrollableAncestor={window}
            // bottomOffset='400px'
            onEnter={({ previousPosition, currentPosition, event }) => {
              //console.log('UNsticky menu')
              this.setState({ toggleSticky: false })
            }}
          ></Waypoint>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>Salome Müller und Philipp Loser</div>
              <div className='ta updated'>Aktualisiert am 1. Februar 2021</div>
            </div>
            <div className='ta text'>
              Am 7. Februar 2021 ist es genau fünfzig Jahre her, seit die
              Schweizer Männer den Schweizer Frauen das Stimmrecht gewährt
              haben. Der Kampf um das Frauenstimmrecht begann aber schon viel
              früher, hundert Jahre früher, und er wurde von Hunderten
              engagierten Frauen und Männern geführt. Aus Anlass des Jubiläums:
              Fünfzig ausgewählte Heldinnen (und ein paar Helden), ohne die es
              das Frauenstimmrecht wahrscheinlich heute noch nicht geben würde.
            </div>
          </div>
        </div>

        <div className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui equal width stackable two column grid'>
              {output}
            </div>
          </div>
        </div>

        <div className='ui vertical segment' style={{ paddingTop: '0' }}>
          <div className='ui text container'>
            <div className='section-teaser'>
              <h5>50 Jahre Frauenstimmrecht</h5>
              <Link
                href={
                  'https://' +
                  parseHostname().publicationDomain +
                  '/frauenstimmrecht'
                }
                hideIcon
              >
                <img
                  src={require('../../images/50_jahre_frauenstimmrecht.jpg')}
                  className='ui image fluid'
                />
              </Link>
            </div>
            <h4>Zum Beitrag</h4>
            <div className='ta text' style={{ fontSize: '0.95em' }}>
              <p>
                Bei den genannten Heldinnen und Helden handelt es sich um eine
                Auswahl. Ein grosser Dank für die Unterstützung geht an
                Historikerin Brigitte Studer von der Universität Bern.
              </p>
              <FeedbackMessage
                question='Fehlen Protagonistinnen, die für die Einführung des Frauenstimmrechts wichtig waren?'
                call='Melden Sie sich mit Hinweisen an '
                mailTo='salome.mueller@tages-anzeiger.ch'
              />
            </div>
            <div className='sources'>
              <h4>Quellen</h4>
              <div className='ta text'>
                Historisches Lexikon der Schweiz. Werner Seitz: «Auf die
                Wartebank geschoben – Der Kampf um die politische Gleichstellung
                der Frauen in der Schweiz seit 1900». Liselotte Lüscher: «Eine
                Frau macht Politik. Marie Boehlen 1911–1999». Léonard Jenni:
                «Selon l’ordre juridique existant, les droits civiques
                appartiennent-ils aux femmes suisses, oui ou non?» Genève 1928.
              </div>
            </div>
          </div>
        </div>

        <Footer
          articleId={ARTICLE_ID}
          hidePortfolioTeaser
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            ['Texte und Recherche', 'Salome Müller, Philipp Loser'],
            ['Bildrecherche', 'Petra Baumann, Olaf Hille'],
            ['Digitale Umsetzung', 'Mathias Lutz']
          ]}
        />

        <TopMenu
          menuOpen={this.state.menuOpen}
          closeMenu={this.closeMenu}
          openMenu={this.openMenu}
          heldinnenData={parseJsonData(heldinnenData)}
        />
      </div>
    )
  }
}
